/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LineupSummariesQueryVariables = {|
  lineupSetID: string
|};
export type LineupSummariesQueryResponse = {|
  +summaryForLineupSet: ?{|
    +playerSummary: ?string,
    +stackSummary: ?string,
  |}
|};
export type LineupSummariesQuery = {|
  variables: LineupSummariesQueryVariables,
  response: LineupSummariesQueryResponse,
|};
*/


/*
query LineupSummariesQuery(
  $lineupSetID: ID!
) {
  summaryForLineupSet(lineupSetId: $lineupSetID) {
    playerSummary
    stackSummary
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lineupSetID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "lineupSetId",
        "variableName": "lineupSetID"
      }
    ],
    "concreteType": "GreenMachineSummaryType",
    "kind": "LinkedField",
    "name": "summaryForLineupSet",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "playerSummary",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stackSummary",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LineupSummariesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LineupSummariesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2d0be5c4c32e22e37ecaf7b60003e7c5",
    "id": null,
    "metadata": {},
    "name": "LineupSummariesQuery",
    "operationKind": "query",
    "text": "query LineupSummariesQuery(\n  $lineupSetID: ID!\n) {\n  summaryForLineupSet(lineupSetId: $lineupSetID) {\n    playerSummary\n    stackSummary\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7ed691edc303af9e10f8c78c17447593';

module.exports = node;
